import {
  Box,
  Button,
  Center,
  Fade,
  Flex,
  FormLabel,
  Input,
  ScaleFade,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import ReactPlayer from "react-player";

type Inputs = {
  videoLink: string;
  buttonCTA: string;
  buttonRedirect: string;
  yPos: string;
  xPos: string;
};

export default function StoryCreator() {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();
  const onSubmit: SubmitHandler<Inputs> = (data) => console.log(data);
  const [playing, setPlaying] = useState(true);
  const [videoSrc, setVideoSrc] = useState("");
  React.useEffect(() => {
    setVideoSrc(watch("videoLink"));
    console.log("called");
  }, [watch("videoLink")]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Flex>
        <Box w="50%" p="2">
          <FormLabel>Video/Photo Url</FormLabel>
          <Input defaultValue="URL" {...register("videoLink")} />
          <br />
          <FormLabel>Button Call To Action</FormLabel>
          <Input defaultValue="View More" {...register("buttonCTA")} />
          <br />
          {/* <FormLabel>x-Position</FormLabel>
          <Input defaultValue="70"  {...register("xPos")}/>
          <br /> */}
          <FormLabel>x-Position</FormLabel>
          <Slider
            aria-label="slider-ex-1"
            onChange={(val) => setValue("xPos", (val * 2).toString())}
          >
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb />
          </Slider>

          <FormLabel>y-Position</FormLabel>
          <Slider
            aria-label="slider-ex-1"
            onChange={(val) => setValue("yPos", (val * 4).toString())}
          >
            <SliderTrack>
              <SliderFilledTrack />
            </SliderTrack>
            <SliderThumb />
          </Slider>
          <br />
          <FormLabel>Button redirect</FormLabel>
          <Input
            defaultValue="https://mystore.com/product/productXYZ"
            {...register("buttonRedirect")}
          />
          {/* <Input {...register("exampleRequired", { required: true })} />
      {errors.exampleRequired && <span>This field is required</span>} */}
        </Box>
        <Box w="50%" p="2">
          <Center>
            <Box
              w={25 * 9}
              h={25 * 16}
              bg="black"
              overflow={"hidden"}
              borderRadius={"15px"}
            >
              {/* <video
                style={{ borderRadius: "15px" }}
                //  crossorigin="anonymous"
                controls
                autoPlay
              >
                <source src={videoSrc} type="video/mp4" />
              </video> */}
              <Box
                onMouseDown={() => setPlaying(false)}
                onMouseUp={() => setPlaying(true)}
                position={"absolute"}
                overflow={"hidden"}
                borderRadius={"15px"}
              >
                <ReactPlayer
                  className="react-player"
                  playing={playing}
                  width={25 * 9}
                  height={25 * 16}
                  playIcon={<Button>Play</Button>}
                  url={videoSrc}
                  muted
                />
              </Box>
              <Button
                colorScheme={"blue"}
                position={"relative"}
                top={`${watch("yPos")}px`}
                left={`${watch("xPos")}px`}
                bg="black"
                color="white"
                borderRadius={"50px"}
                fontSize="0.8em"
                py="0"
                maxW={"200px"}
                overflow="clip"
              >
                {watch("buttonCTA")}
              </Button>
            </Box>
          </Center>
        </Box>
      </Flex>
      <Button
        mt="2"
        type="submit"
        colorScheme="purple"
        bg="black"
        float="right"
      >
        Submit
      </Button>
    </form>
  );
}
